require('./mixins/auto_center.js');
require('./mixins/modal.js');

Pegasus.ModalView = Ember.ContainerView.extend( Pegasus.ModalMixin, Pegasus.AutoCenterMixin, {
  childViews: ['headerView', 'bodyView', 'footerView'],
  submitDisabled: false,
  cancelEnabled: true,
  hasFooterBinding: 'presenter.hasFooter',

  presenterBinding: 'controller.presenter',
  classNameBindings: 'presenter.classNames',
  titleBinding: 'presenter.title',
  widthBinding: 'presenter.width',
  cancelTextBinding: 'presenter.cancelText',
  submitTextBinding: 'presenter.submitText',
  footerTemplateNameBinding: 'presenter.footerTemplateName',
  bodyTemplateNameBinding: 'presenter.bodyTemplateName',
  didSubmitBinding: 'presenter.didSubmit',
  didCancelBinding: 'presenter.didCancel',

  isVisible: function(){
    return !!(this.get('presenter'));
  }.property('presenter'),

  templatesDidChange: function(){
    /*
     * If we could presume that both of these templates would only contain text
     * we could simply bind to a safe string and not rerender.  I've opted for the
     * rerender to allow for more elaborate body and feet templates.
     * */
    this.rerender();
  }.observes('bodyTemplateName', 'footerTemplateName'),

  bodyTemplate: function(){
    if (this.get('bodyTemplateName')) {
      return Ember.TEMPLATES[this.get('bodyTemplateName')];
    }
  }.property('bodyTemplateName'),

  footerTemplate: function(){
    if (this.get('footerTemplateName')) {
      return Ember.TEMPLATES[this.get('footerTemplateName')];
    }
  }.property('footerTemplateName'),

  headerView: Ember.View.extend({
    isVisibleBinding: 'parentView.isVisible',
    classNameBindings: ['parentView.presenter.headerClassName'],
    template: Ember.Handlebars.compile('<a class="close" {{action didCancel target="view.parentView"}}></a><span class="vr-header-title">{{view.parentView.title}}</div>')
  }),

  bodyView: Ember.View.extend({
    isVisibleBinding: 'parentView.isVisible',
    classNameBindings: ['parentView.presenter.bodyClassName'],
    templateBinding: 'parentView.bodyTemplate',
    contextBinding: 'parentView'
  }),

  footerView: Ember.View.extend({
    isVisible: function(){
      return this.get('parentView.isVisible') && this.get('parentView.hasFooter');
    }.property('parentView.isVisible', 'parentView.hasFooter'),

    classNameBindings: ['parentView.presenter.footerClassName'],
    templateBinding: 'parentView.footerTemplate',
    contextBinding: 'parentView'
  }),

  click: function(){
    var presenter = this.get('presenter');
    if(presenter && presenter.click){
      presenter.click.apply( presenter, arguments );
    }
  },

  didChangePresenter: function(){
    $(window).off('keydown.' + this.get('elementId') );

    if( this.get('controller.presenter') ){
      this.set('controller.presenter.view', this);
      Em.run.scheduleOnce( 'afterRender', this.get('controller.presenter'), 'didInsertElement' );
      $(window).on('keydown.' + this.get('elementId'), function(e){
        if ( this.$() && this.get('presenter.pressedKey') ) {
          this.get('presenter').pressedKey.call(this, e.keyCode );
        }
      }.bind(this));
    }
  }.observes('controller.presenter')
});
